import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import UIEventBus from '../EventBus';

interface Toast {
    id: number;
    icon: string;
    message: string;
    color: string;
}

const DeskToast: React.FC = () => {
    const [toasts, setToasts] = useState<Toast[]>([]);
    const counter = useRef(0);

    useEffect(() => {
        UIEventBus.on('deskToast', (data: { icon: string; message: string; color: string }) => {
            const id = ++counter.current;
            setToasts(prev => [...prev, { id, ...data }]);
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id !== id));
            }, 3500);
        });
    }, []);

    return (
        <div style={styles.container}>
            <AnimatePresence>
                {toasts.map(t => (
                    <motion.div
                        key={t.id}
                        initial={{ opacity: 0, y: 16, scale: 0.92 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -8, scale: 0.94 }}
                        transition={{ duration: 0.28, ease: [0.34, 1.56, 0.64, 1] }}
                        style={styles.toast}
                    >
                        <div style={{ ...styles.iconBox, background: t.color + '22', border: `1px solid ${t.color}44` }}>
                            <span style={{ fontSize: 18 }}>{t.icon}</span>
                        </div>
                        <div>
                            <p style={styles.title}>Desk</p>
                            <p style={styles.body}>{t.message}</p>
                        </div>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};

const styles: { [k: string]: React.CSSProperties } = {
    container: {
        position: 'fixed',
        top: 52,
        right: 20,
        zIndex: 9000,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        pointerEvents: 'none',
    },
    toast: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        background: 'rgba(22,22,30,0.88)',
        backdropFilter: 'blur(30px)',
        WebkitBackdropFilter: 'blur(30px)',
        border: '1px solid rgba(255,255,255,0.13)',
        borderRadius: 14,
        boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
        minWidth: 260,
        maxWidth: 340,
    },
    iconBox: {
        width: 36,
        height: 36,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    title: {
        fontSize: 11,
        fontWeight: 600,
        color: 'rgba(255,255,255,0.45)',
        marginBottom: 2,
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    body: {
        fontSize: 13,
        color: 'rgba(255,255,255,0.9)',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        lineHeight: 1.4,
    },
};

export default DeskToast;
